import BrandSlider2 from '../../components/Slider/BrandSlider2'
export default function Brand() {
    return (
        <>
  {/*Brand One Start*/}
  <section className="brand-two">
    <div className="container">
      <BrandSlider2/>
    </div>
  </section>
  {/*Brand One End*/}
</>

    )
}
